import { MAX_SUB_NUMBER_LENGTH } from "../constants"

import type { GlAccount } from "@/graphql/codegen/graphql"

type FormatGlAccountNumberParams = Pick<GlAccount, "number" | "subNumber">

export const formatGlAccountNumber = ({ number, subNumber }: FormatGlAccountNumberParams): string => {
  if (subNumber === null || subNumber === undefined) {
    return String(number)
  }

  return `${number}-${subNumber.toString().padStart(MAX_SUB_NUMBER_LENGTH, "0")}`
}
